var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#002A5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 18.8215L24.1256 14.6965L25.3039 15.8748L21.1789 19.9998L25.3039 24.1248L24.1256 25.3031L20.0006 21.1781L15.8756 25.3031L14.6973 24.1248L18.8223 19.9998L14.6973 15.8748L15.8756 14.6965L20.0006 18.8215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebtn);
export default __webpack_public_path__ + "static/media/closebtn.c789891b8fb3b9f6adf45cede387ee82.svg";
export { ForwardRef as ReactComponent };